import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieHelperService {
  setCookieName(
    cookieName: string,
    cookieValue: string | boolean | number,
    expireDays: number,
    keepSession: boolean,
    pathValue = '',
    domainValue?: string
  ) {
    const cookiesLife = new Date();
    if (expireDays > 0 || keepSession) {
      cookiesLife.setTime(
        cookiesLife.getTime() + expireDays * 24 * 60 * 60 * 1000
      );

      const expires = keepSession
        ? ''
        : '; expires=' + cookiesLife.toUTCString();
      const path = this._getCookiePath(pathValue);
      let cookieDetails = cookieName + '=' + cookieValue + expires + path;
      cookieDetails = this._getCookieDetails(domainValue, cookieDetails);
      document.cookie = cookieDetails;
    }
  }

  private _getCookieDetails(
    domainValue: string | undefined,
    cookieDetails: string
  ) {
    if (domainValue) {
      cookieDetails += `;domain=${domainValue}`;
    }
    return cookieDetails;
  }

  private _getCookiePath(pathValue: string) {
    let path = '';
    if (pathValue) {
      path = `;path=${pathValue}`;
    }
    return path;
  }

  getCookieValue(cookieName: string) {
    const result = new RegExp(
      '(?:^|; )' + encodeURIComponent(cookieName) + '=([^;]*)'
    ).exec(document.cookie);
    return result ? result[1] : null;
  }

  deleteCookie(cookieName: string) {
    const date = new Date();
    date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + '=; expires=' + date.toUTCString() + '; path=/;';
  }
}
